import { IconButton } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const SettingsMenuButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(1),
  backgroundColor: alpha(theme.palette.common.white, 0.1),
  border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
  borderRadius: theme.shape.borderRadius,
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.2),
    borderColor: alpha(theme.palette.common.white, 0.3),
  },
}));
